module.exports = __webpack_public_path__ + "static/media/allImpact_10y_n-1.6a34fc02.csv";